import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import WorkOrderTable from '../WorkOrderTable';
import { EmptyState } from '../empty_state/EmptyState';
import {
	BUYER_WO_FILTERS_ORDER,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import { Alert, Button, message, Modal } from 'antd';
import {
	linkWorkOrderForBuyer,
	linkWorkOrderForSupplier,
	unLinkWorkOrderForBuyer,
	unLinkWorkOrderForSupplier,
	workOrdersRestCrudThunksForBuyer,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	refreshCounts,
	workOrderSearchAndAPIAdaptor,
} from '../../thunks/work_orders_thunks_wrapper';
import WorkOrderCreateButton from '../common/WorkOrderCreateButton';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import {
	compareStrings,
	getEntityById,
	isAdminUser,
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import NoAddWorkOrderHeader from '../WorkOrderTable/TableHeader/noAddWorkOrderHeader';
import './index.less';
import {
	areasRestCrudThunksForBuyer,
	areasRestCrudThunksForSupplier,
} from '../../thunks/areas_thunks';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import { getAreaHierarchyChain } from '../../utils/AreaUtils';
import { getProblemTypeHierarchyChain } from '../../utils/ProblemTypesUtils';
import { isBuyerOrInternalTech, isInternalTech } from '../../utils/AuthUtils';
import DateTimeHover from '../date_time_component/DateTime';
import { UserName } from '../name_component/user/UserNameComponent';
import WorkOrderTableRowBuyer from '../WorkOrderTable/WorkOrderTableRow/buyer';
import WorkOrderTableRowSupplier from '../WorkOrderTable/WorkOrderTableRow/supplier';

const CustomHeaderComponentForLinkedWorkOrders = ({
	selectedUnLinkRowKeys,
	isBuyerAdmin,
	onSubmit,
	showLinkCTA,
	setLinkWoModalVisible,
	newWOParams,
	currentWorkOrderId,
	...props
}) => {
	return (
		<NoAddWorkOrderHeader
			{...props}
			rightActions={
				<>
					{selectedUnLinkRowKeys.length && isBuyerAdmin ? (
						<Button type="default" onClick={() => onSubmit(FORMTYPE.UNLINK, selectedUnLinkRowKeys)}>
							Unlink Selected Work Orders ({selectedUnLinkRowKeys.length})
						</Button>
					) : null}
					{showLinkCTA ? (
						<Button type="default" onClick={() => setLinkWoModalVisible(true)}>
							Link Work Order
						</Button>
					) : null}
					<WorkOrderCreateButton
						align="center"
						size="default"
						backText="Back to WorkOrders"
						title="Create Linked Work Order"
						getLink={(location, BACK_TEXT, path) => {
							const paramsString = new URLSearchParams(newWOParams).toString();
							return getLinkWIthBackLinkParams(location, BACK_TEXT, `${path}?${paramsString}`);
						}}
					/>
				</>
			}
			key={currentWorkOrderId}
		/>
	);
};

const CustomHeaderComponent = ({ selectedRowKeys, loading, onSubmit, ...props }) => {
	return (
		<NoAddWorkOrderHeader
			{...props}
			rightActions={
				<>
					{selectedRowKeys.length ? (
						<Button
							loading={loading}
							type="primary"
							onClick={() => onSubmit(FORMTYPE.LINK, selectedRowKeys)}
						>
							Link Selected Work Orders ({selectedRowKeys.length})
						</Button>
					) : null}
				</>
			}
		/>
	);
};

const FORM_ID = 'wo-link-work-orders-form';
const FORMTYPE = {
	LINK: 'Link',
	UNLINK: 'Unlink',
};

const TC_NAME = 'linkedWorkOrders';

function LinkedWorkOrders({
	match,
	currentWorkOrder,
	linkWorkOrders,
	unlinkWorkOrders,
	getWorkOrder,
	fetchWorkOrders,
	workOrders,
	WOrefreshCounts,
	fetchAreas,
	fetchProblemTypes,
	userType,
	currentUser,
	companyConfig,
	location,
}) {
	const currentWorkOrderId = match.params.id;

	const [linkWoModalVisible, setLinkWoModalVisible] = useState(false);

	const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
	const [selectedUnLinkRowKeys, setSelectedUnlinkRowKeys] = React.useState<React.Key[]>([]);
	const [loading, setLoading] = useState(false);
	const [newWOParams, setNewWOParams] = useState({});

	const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};
	const onSelectUnlinkChange = (newSelectedRowKeys: React.Key[]) => {
		setSelectedUnlinkRowKeys(newSelectedRowKeys);
	};

	const isBuyerAdmin = userType === ROLE_TYPES.BUYER && isAdminUser(currentUser);

	useEffect(() => {
		prepareCreateNewWorkOrder();
	}, [currentWorkOrderId]);

	const LinkedWorkOrderRow = ({ record }) => {
		const currentlinkedWOObj = nullSafeGetOrElse('linkedToWorkOrders', record, []).find(
			(item) => nullSafeGet('workOrderId', item) == currentWorkOrderId
		);

		const showUnlinkActive =
			isBuyerAdmin ||
			nullSafeGet('linkedBy', currentlinkedWOObj) === nullSafeGet('email', currentUser);

		const actions = [];
		if (nullSafeGet('linkedByContact', currentlinkedWOObj)) {
			actions.push(
				<div className=" flex flex-col items-center " style={{ width: 200 }}>
					<Button
						disabled={!showUnlinkActive}
						type="ghost"
						loading={loading}
						onClick={() => {
							onSubmit(FORMTYPE.UNLINK, [record.id]);
						}}
					>
						Unlink
					</Button>
					<div className="ml-6  mt-2 flex flex-col justify-center text-gray-400">
						Linked By{' '}
						<UserName
							mode="inline"
							contact={currentlinkedWOObj.linkedByContact}
							extraDetails={[
								{
									key: 'linkedAt',
									display: 'Linked',
									value: (
										<DateTimeHover
											timestamp={currentlinkedWOObj.linkedAt}
											timeZone={nullSafeGet('location.timeZoneId', currentWorkOrder)}
										/>
									),
								},
							]}
						/>
					</div>
				</div>
			);
		}

		const WorkOrderTableRow =
			userType === ROLE_TYPES.SUPPLIER ? WorkOrderTableRowSupplier : WorkOrderTableRowBuyer;

		return (
			<WorkOrderTableRow
				record={record}
				currentUser={currentUser}
				companyConfig={companyConfig}
				location={{ pathname: location.pathname, search: '' }}
				actions={actions}
				backText="Back to Work Order"
			/>
		);
	};

	const rowSelection = React.useMemo(
		() => ({
			selectedRowKeys,
			onChange: onSelectChange,
			getCheckboxProps: (record) => ({
				disabled: [
					nullSafeGet('id', currentWorkOrder),
					...nullSafeGetOrElse('linkedToWorkOrders', currentWorkOrder, []).map(
						(i) => i.workOrderId
					),
				].includes(record.id),
			}),
		}),
		[selectedRowKeys, currentWorkOrder]
	);
	const rowUnlinkSelection = React.useMemo(
		() => ({
			selectedUnLinkRowKeys,
			onChange: onSelectUnlinkChange,
		}),
		[selectedUnLinkRowKeys]
	);

	const getStateSliceProp = useCallback(
		(propName) => nullSafeGetOrElse(`${TC_NAME}.${propName}`, workOrders, {}),
		[workOrders]
	);

	const refreshWorkOrderTable = useCallback(() => {
		fetchWorkOrders(
			{},
			TC_NAME,
			getStateSliceProp('pagination'),
			getStateSliceProp('sorting'),
			getStateSliceProp('filters')
		);
		WOrefreshCounts(TC_NAME, getStateSliceProp('filters'));
	}, [fetchWorkOrders, getStateSliceProp, WOrefreshCounts]);

	const onSubmit = useCallback(
		(formType, ids) => {
			const handleWorkOrderLinking = (action) => {
				setLoading(true);
				action(currentWorkOrderId, ids, true)
					.catch(() => {
						message.error(`Failed to ${formType.toLowerCase()} Work Orders`);
					})
					.finally(() => {
						setLoading(false);
						setSelectedRowKeys([]);
						setSelectedUnlinkRowKeys([]);
						getWorkOrder(currentWorkOrderId);
						setLinkWoModalVisible(false);
						refreshWorkOrderTable();
					});
			};

			if (compareStrings(formType, FORMTYPE.LINK)) {
				handleWorkOrderLinking(linkWorkOrders);
			} else if (compareStrings(formType, FORMTYPE.UNLINK)) {
				handleWorkOrderLinking(unlinkWorkOrders);
			}
		},
		[currentWorkOrderId, linkWorkOrders, unlinkWorkOrders, getWorkOrder, refreshWorkOrderTable]
	);

	const prepareCreateNewWorkOrder = () => {
		const promises = [
			fetchAreas({ locationId: currentWorkOrder.locationId }, 'areas', {}, {}, {}),
			fetchProblemTypes({}, 'problemTypes', {}, {}, {}),
		];
		Promise.all(promises).then((data) => {
			const [areas, problemTypes] = data;
			const areaHeirarchy = getAreaHierarchyChain(areas, currentWorkOrder.areaId);
			const areasTier = ['areasTopLevel', 'areaId', 'areaIdNextLevel'];
			const areaIds = {};
			areaHeirarchy.map((area, index) => {
				areaIds[areasTier[index]] = area.id;
			});

			const problemTypeHeirarchy = getProblemTypeHierarchyChain(
				problemTypes,
				currentWorkOrder.problemTypeId
			);

			const problemTypesTier = ['problemTypeTopLevel', 'problemTypeId', 'problemTypeIdNextLevel'];
			const problemTypeIds = {};
			problemTypeHeirarchy.map((problemType, index) => {
				problemTypeIds[problemTypesTier[index]] = problemType;
			});
			const params = {
				locationId: currentWorkOrder.locationId,
				images: currentWorkOrder.images || [],
				linkedWorkOrderId: currentWorkOrder.id,
				...areaIds,
				...problemTypeIds,
				assetId: currentWorkOrder.assetId,
				isAssetDown: currentWorkOrder.isAssetDown,
				supplierFacilityId: currentWorkOrder.supplierFacilityId,
				submittedByName: currentWorkOrder.submittedByName,
			};

			const filteredParams = Object.fromEntries(
				Object.entries(params).filter(([_, value]) => value !== undefined && value !== null)
			);

			setNewWOParams(filteredParams);
		});
	};
	const filters = useMemo(() => {
		if (userType === ROLE_TYPES.BUYER) {
			return BUYER_WO_FILTERS_ORDER;
		} else {
			return isInternalTech(currentUser)
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER;
		}
	}, [userType, currentUser]);
	const showLinkCTA = useMemo(() => {
		return isBuyerOrInternalTech(currentUser);
	}, [currentUser]);

	const initialFilters = useMemo(() => {
		const filters: any = {};
		filters.locationIds = [currentWorkOrder.locationId];
		if (ROLE_TYPES.BUYER === userType) {
			if (currentWorkOrder.supplierFacilityId) {
				filters.supplierFacilityIds = [currentWorkOrder.supplierFacilityId];
			}
			return filters;
		}
	}, [userType, currentWorkOrder.locationId, currentWorkOrder.supplierFacilityId]);

	const preAppliedFilters = useMemo(() => {
		const filters: any = {};
		if (ROLE_TYPES.SUPPLIER === userType) {
			filters.buyerCompanyId = currentWorkOrder.buyerCompanyId;
		}
		return filters;
	}, [userType, currentWorkOrder.buyerCompanyId]);

	return (
		<>
			<WorkOrderTable
				CustomHeaderProps={{
					selectedUnLinkRowKeys,
					isBuyerAdmin,
					onSubmit,
					showLinkCTA,
					setLinkWoModalVisible,
					newWOParams,
					currentWorkOrderId,
				}}
				CustomWorkOrderRowDisplay={LinkedWorkOrderRow}
				CustomHeader={CustomHeaderComponentForLinkedWorkOrders}
				preAppliedFilters={{ baseLinkedWorkOrderId: currentWorkOrderId }}
				filterConfig={{
					filters,
				}}
				renderEmptyState={(currentUser) => (
					<EmptyState
						headline="No linked Work Orders"
						body={
							<div>
								<p>There are no linked Work Orders available for this Work Order.</p>
								{showLinkCTA ? (
									<Button type="default" onClick={() => setLinkWoModalVisible(true)}>
										Link Work Order
									</Button>
								) : null}
							</div>
						}
					/>
				)}
				targetCollectionName="linkedWorkOrders"
				rowSelection={isBuyerAdmin ? rowUnlinkSelection : null}
				key="linkedWorkOrders"
			/>
			{linkWoModalVisible ? (
				<Modal
					width="80%"
					visible
					title={'Link Work Orders'}
					closable
					onCancel={() => setLinkWoModalVisible(false)}
					forceRender
					footer={<Button onClick={() => setLinkWoModalVisible(false)}>Cancel</Button>}
					wrapClassName="linked-work-orders-modal"
				>
					<div className="mt-4">
						{nullSafeGet('linkedToWorkOrders.length', currentWorkOrder) ? (
							<Alert
								message={`${nullSafeGet(
									'linkedToWorkOrders.length',
									currentWorkOrder
								)} Work Order(s) linked`}
								description={nullSafeGet('linkedToWorkOrders', currentWorkOrder)
									.map((i) => `WO #${i.workOrderId || ''}`)
									.join(', ')}
								type="info"
							/>
						) : null}
					</div>
					<WorkOrderTable
						CustomWorkOrderRowDisplay={LinkedWorkOrderRow}
						key="linkedWorkOrdersModal"
						preAppliedFilters={preAppliedFilters}
						filterConfig={{
							filters,
						}}
						initialFilters={initialFilters}
						renderEmptyState={(currentUser) => <EmptyState headline="No Work Orders" />}
						rowSelection={rowSelection}
						targetCollectionName="linkedWorkOrdersModal"
						CustomHeaderProps={{ selectedRowKeys, onSubmit, loading }}
						CustomHeader={CustomHeaderComponent}
					/>
				</Modal>
			) : null}
		</>
	);
}

const mapStateToProps = (state, ownProps) => ({
	workOrders: state.work_orders,
	currentWorkOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleWorkOrders: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: workOrdersRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchWorkOrders: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.searchAndHydrate(
						{ ...params },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection,
						workOrderSearchAndAPIAdaptor
				  )
				: workOrdersRestCrudThunksForBuyer.searchAndHydrate(
						{ ...params },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection,
						workOrderSearchAndAPIAdaptor
				  )
		),
	linkWorkOrders: (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? linkWorkOrderForSupplier(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
				: linkWorkOrderForBuyer(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
		),
	unlinkWorkOrders: (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? unLinkWorkOrderForSupplier(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
				: unLinkWorkOrderForBuyer(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)
		),
	getWorkOrder: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.readOne(id)
				: workOrdersRestCrudThunksForBuyer.readOne(id)
		),
	WOrefreshCounts: (targetCollectionName, filters) =>
		dispatch(refreshCounts(ownProps.userType)(targetCollectionName, filters)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? areasRestCrudThunksForSupplier.readLite(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: areasRestCrudThunksForBuyer.readLite(
						{ ...params, no_pagination: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier
				: problemTypesHeirarchicalForBuyer;
		return dispatch(
			fnToCall(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection)
		);
	},
});

const ComponentWithoutUserType = connect(mapStateToProps, mapDispatchToProps)(LinkedWorkOrders);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
